import { API_CALENDAR_EVENTS } from 'config'
import Api from 'services/api'

export interface ICalendarEvent {
  id: number
  loanNumber: number
  title: string
  date: string
  type: string
  borrowerName?: string
  propertyAddress?: string
  loanStatus?: string
}

export interface IGetCalendarEventsParams {
  year: number
  month: number
  eventTypes?: string[]
  status?: string[]
}

export const getCalendarEvents = (params: IGetCalendarEventsParams): Promise<ICalendarEvent[]> => {
  return Api.get(API_CALENDAR_EVENTS, params)
}

